const devuelveCategorias = () => {

    let Categorias = [

        // =========================
        // HISTORICAS
        // =========================

        {
            id: 1,
            descripcion: "Baja",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 2,
            descripcion: "Reincorporacion",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 3,
            descripcion: "Designacion",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 4,
            descripcion: "Recurso",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 5,
            descripcion: "Apelacion en Subsidio",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 6,
            descripcion: "Pago Docente",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 7,
            descripcion: "Solicitud de Servicio Externo",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 8,
            descripcion: "Notificacion Externa",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 9,
            descripcion: "Nota de Pedido",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 10,
            descripcion: "Notas Varias",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 11,
            descripcion: "Nacional",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 12,
            descripcion: "LTB",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 13,
            descripcion: "Información Sumaria",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 14,
            descripcion: "Sumario Administrativo",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 15,
            descripcion: "Oficio Judicial",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 16,
            descripcion: "Credenciales",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 17,
            descripcion: "Capacitaciones",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 18,
            descripcion: "Cambio de Sede",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 19,
            descripcion: "Renuncia de Cursado",
            vigente: false,
            grupo: "Históricas"
        },
        {
            id: 20,
            descripcion: "Exclusión de Cursado",
            vigente: false,
            grupo: "Históricas"
        },

        // =========================
        // GESTIÓN CURRICULAR
        // =========================

        {
            id: 101,
            descripcion: "Baja de Cursante",
            vigente: true,
            grupo: "Gestión Curricular"
        },
        {
            id: 102,
            descripcion: "Reincorporación de Cursante",
            vigente: true,
            grupo: "Gestión Curricular"
        },
        {
            id: 103,
            descripcion: "Exclusión de Cursado",
            vigente: true,
            grupo: "Gestión Curricular"
        },
        {
            id: 104,
            descripcion: "Mesa de Examen / Evaluación",
            vigente: true,
            grupo: "Gestión Curricular"
        },
        {
            id: 105,
            descripcion: "Cambio de Sede / Permuta Cadete",
            vigente: true,
            grupo: "Gestión Curricular"
        },
        {
            id: 106,
            descripcion: "Situación Académica / Revista",
            vigente: true,
            grupo: "Gestión Curricular"
        },
        {
            id: 107,
            descripcion: "Inscripción / Ingreso / Propedéutico",
            vigente: true,
            grupo: "Gestión Curricular"
        },
        {
            id: 108,
            descripcion: "Gestión de Inasistencias",
            vigente: true,
            grupo: "Gestión Curricular"
        },
        {
            id: 109,
            descripcion: "Informe de Causa / Antecedentes Cadete",
            vigente: true,
            grupo: "Gestión Curricular"
        },
        {
            id: 110,
            descripcion: "Solicitud de Entrevista",
            vigente: true,
            grupo: "Gestión Curricular"
        },

        // =========================
        // GESTIÓN ACADÉMICA
        // =========================

        {
            id: 201,
            descripcion: "Gestión Docente",
            vigente: true,
            grupo: "Gestión Académica"
        },
        {
            id: 202,
            descripcion: "Capacitación / Curso Extracurricular",
            vigente: true,
            grupo: "Gestión Académica"
        },

        // =========================
        // ASUNTOS LEGALES / DISCIPLINARIOS
        // =========================

        {
            id: 301,
            descripcion: "Recurso / Apelación",
            vigente: true,
            grupo: "Asuntos Legales / Disciplinarios"
        },
        {
            id: 302,
            descripcion: "Sumario / Disciplinario",
            vigente: true,
            grupo: "Asuntos Legales / Disciplinarios"
        },
        {
            id: 303,
            descripcion: "Oficio Judicial / Legal",
            vigente: true,
            grupo: "Asuntos Legales / Disciplinarios"
        },

        // =========================
        // RRHH / PERSONAL POLICIAL
        // =========================

        {
            id: 401,
            descripcion: "Gestión de Licencias",
            vigente: true,
            grupo: "RRHH / Personal Policial"
        },
        {
            id: 402,
            descripcion: "Salud / Psicopedagógico",
            vigente: true,
            grupo: "RRHH / Personal Policial"
        },
        {
            id: 403,
            descripcion: "Trámites Personal Policial",
            vigente: true,
            grupo: "RRHH / Personal Policial"
        },
        {
            id: 404,
            descripcion: "Asignaciones Familiares / Haberes",
            vigente: true,
            grupo: "RRHH / Personal Policial"
        },

        // =========================
        // LOGÍSTICA Y SOPORTE
        // =========================

        {
            id: 501,
            descripcion: "Logística / Infraestructura",
            vigente: true,
            grupo: "Logística y Soporte"
        },
        {
            id: 502,
            descripcion: "Servicio Externo / Adicional",
            vigente: true,
            grupo: "Logística y Soporte"
        },
        {
            id: 503,
            descripcion: "Informe Institucional / Comunicación",
            vigente: true,
            grupo: "Logística y Soporte"
        }

    ]

    Categorias.sort((a, b) =>
        a.descripcion.localeCompare(b.descripcion)
    );

    return Categorias
}

export default devuelveCategorias